import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin: auto;
`;

const Circle = styled.div`
  height: 45px;
  width: 45px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  &:hover {
    cursor: pointer;
  }
`;

export { Container, Circle };
